/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import addIdentityRegionaleActions, {
    addIdentityRegionaleTypes,
} from '../../redux/identityRegionale/addIdentityRegionale'
import { Post } from '../../serveur/axios'
import alertActions from '../../redux/alert'

function* addIdentityRegionaleSagas({ response }) {
    try {
        const res = yield Post(`identityRegion/`, response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    addIdentityRegionaleActions.addIdentityRegionaleSuccess(
                        res.data
                    )
                ),

                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(goBack()),
            ])
        } else {
            yield put(
                addIdentityRegionaleActions.addIdentityRegionaleFailure(res)
            )
        }
    } catch (error) {
        yield put(
            addIdentityRegionaleActions.addIdentityRegionaleFailure(error)
        )
    }
}

export function* addIdentityRegionale() {
    yield takeLatest(
        addIdentityRegionaleTypes.ADD_IDENTITY_REGIONALE_REQUEST,
        addIdentityRegionaleSagas
    )
}
